import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Deal, DealPagedRequest, DealPayment, PagedResponse, PaymentsPagedRequest } from './model';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DealService {

  constructor(private http: HttpClient) { }

  get(id: number): Observable<Deal> {
    return this.http.get<Deal>(
      `${environment.apiUrl}/Admin/GetDealByCRMId/${id}`);
  }

  list(req: DealPagedRequest): Observable<PagedResponse<Deal>> {
    return this.http.post<PagedResponse<Deal>>(
      `${environment.apiUrl}/Admin/GetDeals`, req);
  }

  getOverduePayments(req: DealPagedRequest): Observable<PagedResponse<Deal>> {
    return this.http.post<PagedResponse<Deal>>(
      `${environment.apiUrl}/Admin/GetOverduePayments`, req);
  }


  allPayments(req: PaymentsPagedRequest): Observable<PagedResponse<DealPayment>> {
    return this.http.post<PagedResponse<DealPayment>>(
      `${environment.apiUrl}/Admin/GetPayments`, req);
  }

  exportPayments(req: PaymentsPagedRequest): Observable<Blob> {
    return this.http.post<Blob>(
      `${environment.apiUrl}/Admin/ExportPayments`, req, { responseType: 'blob' } as any) as any;
  }

  upcomingPayments(req: DealPagedRequest): Observable<PagedResponse<DealPayment>> {
    return this.http.post<PagedResponse<DealPayment>>(
      `${environment.apiUrl}/Admin/GetUpcomingPayments`, req);
  }

  previewOfferPDF(dealId: string): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/Admin/PreviewOfferPDF/${dealId}`, { responseType: 'blob' });
  }

  updateDealDataForRenewal(dealId: string): Observable<Deal> {
    return this.http.get<Deal>(
      `${environment.apiUrl}/Admin/UpdateDealDataForRenewal/${dealId}`);
  }

  modifyPayment(paymentId: number, dueDate: Date, comments: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/Admin/UpdatePaymentDate`, { PaymentId: paymentId, NewDate: dueDate, ModificationComments: comments });
  }
}
